import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-data",
  "use": "icon-data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-data\"><path d=\"M579.82906 450.334415 1023.556141 450.334415C1023.556141 450.334415 1024.957734 32.501861 579.82906 0.804752\" p-id=\"2220\" /><path d=\"M895.638662 569.052514C895.638662 819.596674 695.169719 1022.735209 447.824333 1022.735209 200.502701 1022.735209 0 819.596674 0 569.052514 0 318.477941 200.4977 115.349545 447.824333 115.349545L447.824333 569.052514 895.638662 569.052514 895.638662 569.052514Z\" p-id=\"2221\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol